
var React = require("react");
var DataHelper = require("./DataHelper.js");
var ApplicationContext = require("./config/ApplicationContext.js");

class DataContext extends React.Component {
    render() {
        return (
            <script dangerouslySetInnerHTML= {{
                __html: `
                    window.LIBRARY_ASSET_URL="${ApplicationContext.assetUrlPrefix}";
                    var __app = __app || {};
                    __app.dataContext = ${JSON.stringify(DataHelper.getAppData(this.props))};
                `
            }} />
        ); 
    }
};

module.exports = DataContext;


